import type { OeeThresholds } from "@/hooks/useOrganizationPolicy";

// Spec 079 (T051/FR-030) — as cores do OEE RECEBEM os limiares, não os declaram.
//
// Eram `85` e `65` escritos aqui. Dois problemas, e o segundo é o caro: (1) mudar a régua de cor da
// fábrica exigia PR e deploy; (2) o `85` existia numa SEGUNDA cópia, hardcoded em
// `apps/api/src/features/oee/oee-confidence.ts`, e nada mantinha as duas sincronizadas — quem
// mudasse aqui passaria a ver o painel verde e o diagnóstico dizendo "Disponibilidade é o
// componente menor" ao mesmo tempo.
//
// As funções continuam PURAS: os limiares entram por argumento, e é isso que permite ao mesmo
// código servir o painel, a cena 3D e a tabela de ordens sem nenhum deles conhecer a organização.
// Quem os obtém é `useOeeThresholds()`, na borda React.

export function thresholdColor(value: number | null, t: OeeThresholds): string {
  if (value === null) return "bg-muted";
  if (value >= t.good) return "bg-status-running";
  if (value >= t.warn) return "bg-status-idle";
  return "bg-status-stopped";
}

export type OeeTone = "success" | "warning" | "danger" | "neutral";

export function thresholdTone(value: number | null, t: OeeThresholds): OeeTone {
  if (value === null) return "neutral";
  if (value >= t.good) return "success";
  if (value >= t.warn) return "warning";
  return "danger";
}
